import { Pipe, PipeTransform } from '@angular/core';
import { SharedService } from '@app/core/services/shared/shared.service';

@Pipe({
  name: 'DecimalNumber',
  standalone: false,
})
export class DecimalNumberPipe implements PipeTransform {
  constructor(private sharedService: SharedService) {}

  transform(value: number, args?: any): any {
    const decimalPlace =
      this.sharedService?.getCustomerDetails?.customizationsText
        ?.GlobalDecimalSetting;
    return (value || 0).toFixed(decimalPlace || 2);
  }
}
